export default () => ({
  id: null,
  locations: [],
  opportunities: [],
  regions: [],
  assigned_admin: [],
  requested_department: [],
  client: [],
  date_from: null,
  date_to: null,
  amount_low: null,
  amount_high: null,
  keywords: null,
  management: null,
  talent: [],
  sort: 'created_at',
  order: 'desc'
})
